import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const propTypes = {
    isCountElements: PropTypes.bool,
    countForChecked: PropTypes.number,
    title: PropTypes.string.isRequired,
    elementsForChecked: PropTypes.array,
    elements: PropTypes.array.isRequired,
    elemOnClick: PropTypes.func.isRequired,
    headerOnClick: PropTypes.func.isRequired,
    isActiveAccord: PropTypes.bool.isRequired
};

const SelectedItems = ({elements, elementsForChecked, isCountElements, countForChecked, onClick}) => {
    let displayElements = () => {
        if (isCountElements) {
            if (countForChecked === undefined || countForChecked === 0) {
                return <span/>
            }
            return (
                <div className="delete-tag-enter" onClick={() => {
                    onClick(countForChecked)
                }}>
                    {countForChecked}
                </div>
            );
        }

        if (elementsForChecked === undefined || elements === undefined) {
            return <span/>
        }
        return elementsForChecked.map(e => {
            return (
                <div className="delete-tag-enter" key={'tag_' + e} onClick={() => {
                    onClick(e)
                }}>
                    {elements.filter(el => el.value === e)[0].title}
                </div>
            );
        });
    };

    return (
        <div className="delete-tag">
            <div className="delete-tags">
                {displayElements()}
            </div>
        </div>
    );
};

const FiltersAccordItem = ({
                               title,
                               elements,
                               elemOnClick,
                               headerOnClick,
                               isActiveAccord,
                               isCountElements,
                               countForChecked,
                               elementsForChecked
                           }) => {
    return (
        <div className="filters_accord_item">
            <a
                href=""
                onClick={headerOnClick}
                className={classnames('filter_accord_header', {
                    'active_accord': isActiveAccord
                })}
            >
                {title}
            </a>
            <ul
                className={classnames('filter_accord_content', {
                    'rn-active': isActiveAccord
                })}
            >
                {isCountElements ?
                    elements.map((count, index, array) => (
                        <li
                            key={count}
                            onClick={() => elemOnClick(count)}
                            className={classnames({
                                'checked': countForChecked === count
                            })}
                        >
                            {index === array.length - 1 ? `${count}+` : count}
                        </li>
                    ))
                    :
                    elements.map(elem => (
                        <li
                            key={elem.value}
                            onClick={() => elemOnClick(elem.value)}
                            className={classnames({
                                'checked': elementsForChecked.includes(elem.value)
                            })}
                        >
                            {elem.title}
                        </li>
                    ))
                }
            </ul>

            <SelectedItems
                elements={elements}
                elementsForChecked={elementsForChecked}
                onClick={elemOnClick}
                isCountElements={isCountElements}
                countForChecked={countForChecked}
            />
        </div>
    );
};

FiltersAccordItem.propTypes = propTypes;

export default FiltersAccordItem;



// WEBPACK FOOTER //
// ./src/components/Search/FiltersAccordItem.js